import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider, useAuth } from "./AuthContext";
import Studio from "./Studio";
import PublicQuote from "./PublicQuote";
import Login from "./Login";
import Setup from "./Setup";
import ResetPassword from "./ResetPassword";
import "@/App.css";

function ThemeInit() {
  useEffect(() => {
    const color = localStorage.getItem("app-primary-color");
    if (color) document.documentElement.style.setProperty("--blue", color);
  }, []);
  return null;
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="fullscreen-loading">Yükleniyor…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeInit />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/quote/public/:ref" element={<PublicQuote />} />
          <Route path="*" element={<Protected><Studio /></Protected>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
